const CLIENT_ID = process.env.REACT_APP_CLIENT_ID ?? "0oa1zgrkex49GDlrQ1d7";
const ISSUER =
  process.env.REACT_APP_ISSUER ??
  "https://agent-login.oktapreview.com/oauth2/aus1xj63z0avW7AmU1d7";
const OKTA_TESTING_DISABLEHTTPSCHECK =
  process.env.REACT_APP_OKTA_TESTING_DISABLEHTTPSCHECK === "true";
const REDIRECT_URI = `${window.location.origin}/login/callback`;
const REDIRECT_HOME_PORTAL_THEME =
  process.env.REACT_APP_REDIRECT_HOME_PORTAL_THEME ?? "HOME_PORTAL";
const REDIRECT_HOME_PORTAL_URL =
  process.env.REACT_APP_REDIRECT_HOME_PORTAL_URL ?? "https://app.hottehome.com";
const REDIRECT_LUXURY_PORTAL_THEME =
  process.env.REACT_APP_REDIRECT_LUXURY_PORTAL_THEME ?? "LTCHOME_PORTAL";
const REDIRECT_LUXURY_PORTAL_URL =
  process.env.REACT_APP_REDIRECT_LUXURY_PORTAL_URL ??
  "https://fclh.my.site.com/ltchome";
const REDIRECT_OTHER_URL =
  process.env.REACT_APP_REDIRECT_OTHER_URL ??
  "https://agent-login.oktapreview.com/app/UserHome";

console.log(process.env.REACT_APP_REDIRECT_OTHER_URL);

// eslint-disable-next-line
export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ["openid", "profile", "email", "theme"],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  },
  redirect: {
    redirectHomePortalTheme: REDIRECT_HOME_PORTAL_THEME,
    redirectHomePortalUrl: REDIRECT_HOME_PORTAL_URL,
    redirectLuxuryPortalTheme: REDIRECT_LUXURY_PORTAL_THEME,
    redirectLuxuryPortalUrl: REDIRECT_LUXURY_PORTAL_URL,
    redirectOtherUrl: REDIRECT_OTHER_URL,
  },
};
